import { Component } from '@angular/core';
import { NavController, Events, App, LoadingController } from 'ionic-angular';
import { UserData } from '../../../../providers/user-data';
import { PageBaseFull } from '../../../../core/page-base.full';
import { AppSettings } from '../../../../config/app-settings';
import { HomeCommon } from './home.common';

@Component({
	selector: 'page-home-full',
  	templateUrl: 'home.full.html'
})

export class HomePageFull extends PageBaseFull {
	
	public pageSections:any;
	public loader: any;

	constructor(
		public settings: AppSettings,
		public events: Events,
		public nav: NavController,
		public userData: UserData,
		public common: HomeCommon,
        public loadingCtrl: LoadingController,
        public app: App

	) {
		super(settings, events, nav, userData);
		this.loader = this.loadingCtrl.create();
	}

	ngAfterViewInit() {
		let self = this;
		self.loader.present();
		self.common.getHomeWidgets().subscribe((sections) =>{
			self.pageSections = sections;
			console.log(sections);
			// self.loader.dismiss();
			setTimeout(()=>{
				console.log("Custom script to Load when page loaded");
				self.appendFooterScripts('assets-full/base/js/page-loaded.js');	
				self.appendFooterScripts('assets-full/base/js/scripts/pages/isotope-grid.js');
			}, 400);
		});
		self.loader.dismiss();
	}
	
	ionViewDidEnter() {
		this.app.setTitle('Home Page');
	}
}


// WEBPACK FOOTER //
// ./src/modules/home/pages/home/home.full.ts